import { CommonDialogs } from "@mcleod/common";
import { AddType, EditRowDecorator, SaveButton, Table, TableColumn, Toast } from "@mcleod/components";
import { Api, HorizontalAlignment, ObjectUtil } from "@mcleod/core";
import { AutogenLayoutResponsibilityManageHierarchyLevel } from "./autogen/AutogenLayoutResponsibilityManageHierarchyLevel";

export class ResponsibilityManageHierarchyLevel extends AutogenLayoutResponsibilityManageHierarchyLevel {

    private _isHierarchyExist: boolean = false;
    public get isHierarchyExist(): boolean {return this._isHierarchyExist; }
    public set isHierarchyExist(value: boolean) {this._isHierarchyExist = value; }

    override onLoad() {
        const columnLevel: TableColumn = this.tableHierarchyLevel.getColumnByCaption("Level");
        if (columnLevel) {
            columnLevel.headingCell.align = HorizontalAlignment.LEFT;
        }
        this.showToolcell();
        this.mainDataSource.orderBy = [{ field: "level_number", sort: "asc" }]
    }

    async showToolcell() {
        const response = await Api.search("lme/general/validate-hierarchy", { "operation": "Hierarchy" });
        const data = response.data[0];
        if (data) {
            this.isHierarchyExist = data.hierarchy_exists;
            if (this.isHierarchyExist) {
                const tableHierarchyLevel: Table = this.tableHierarchyLevel;
                tableHierarchyLevel.displayToolsCell = false;
                tableHierarchyLevel.addType = AddType.NOT_ALLOWED;
                tableHierarchyLevel.allowEdit = false;
                tableHierarchyLevel.allowDelete = false;
                this.panelInfo.visible = true;
                this.labelInfo.text = "Hierarchy Levels can only be viewed after the Hierarchy is created.";
            }
        }
    }

    showHierarchyLevelSlideout(isHierarchyExist: boolean, refreshTree: boolean, populateTree?: () => Promise<void> | void) {
        const title = isHierarchyExist ? "View Hierarchy Levels" : "Manage Hierarchy Levels";
        const saveButton = this.createSaveButton(refreshTree, populateTree);
        new EditRowDecorator({
            layout: this,
            fillVerticalSpace: true,
            width: "60%",
            title: title,
            overlayProps: { greyedBackground: true, closeOnClickOff: false },
            layoutLoadListeners: () => {
                if (this.isHierarchyExist) {
                    saveButton.visible = false;
                    const tableHierarchyLevel: Table = this.tableHierarchyLevel;
                    tableHierarchyLevel.displayToolsCell = false;
                    tableHierarchyLevel.addType = AddType.NOT_ALLOWED;
                    tableHierarchyLevel.allowEdit = false;
                    tableHierarchyLevel.allowDelete = false;
                    this.panelInfo.visible = true;
                    this.labelInfo.text = "Hierarchy Levels can only be viewed after the Hierarchy is created.";
                }
            },
            addlComponents: saveButton,
            onClose: async (cancelled: boolean) => {
                this.slideOut();
            },
        });
    }

    private createSaveButton(refreshTree: boolean, populateTree: () => Promise<void> | void): SaveButton {
        const saveButton = SaveButton.create({ caption: "Save & Close", id: "hierarchyLevelSaveButton", rowBreak: false, enabled: false });
        this.mainDataSource.addHasChangedComponent(saveButton);
        saveButton.addClickListener(() => {
            try {
                const primaryButton = saveButton.primaryButton;
                primaryButton.makeBusyWhile(this.postToHierarchyLevelTable(refreshTree, populateTree));
            } catch (error) {
                CommonDialogs.showError(error);
            }
        });
        return saveButton;
    }

    serializeDataToPost(): any {
        const data = {
            post_rows: this.mainDataSource.data.filter(row => row.hasChanged()),
            delete_rows: this.mainDataSource.deletedData
        }
        return data;
    }

    async postToHierarchyLevelTable(refreshTree: boolean, populateTree: () => Promise<void> | void) {
        const dataToPost = this.serializeDataToPost();
        if (ObjectUtil.isEmptyObject(dataToPost, true)) {
            return;
        }
        const response = await Api.post("lme/general/hierarchy-level-post", dataToPost);
        if (response) {
            const message = response?.data[0]?.message || "Hierarchy Level Added/Updated Successfully";
            Toast.showToast(message);
            await this.delay(2000);
            this.mainDataSource.data.forEach(row => {
                row._appending = false;
                row.resetOriginalData();
            });
            if (this.mainDataSource.deletedData) {
                this.mainDataSource.deletedData.length = 0;
            }
            this.slideOut();
            if (refreshTree) {
                await populateTree();
            }
        }
    }

    delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

}
